var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ASSIGNMENTS_EVENT_CATEGORIES = {
    assignmentsListPage: "assign_default_page",
    createAssignmentPage: "assign_add_assignment_page",
    assignmentDetailsPage: "assign_report_page",
};
var AssignmentsListPageEvents = {
    pageVisit: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_visit",
    cancelClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_cancel_click",
    reassignClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_reassign_click",
    addNewClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_addnew_click",
    statusLegendShow: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_statustip_hover",
    showMoreClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_showmore_click",
    assignmentDetailsClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_assignment_click",
    filterAllClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_filterall_click",
    filterInProgressClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_filter_inprogress_click",
    filterCompletedClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_filter_completed_click",
    filterScheduledClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage + "_filter_scheduled_click",
};
var CreateAssignmentPageEvents = {
    studentsAllClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_studentsall_click",
    studentsOnGradeClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_students_ongrade_click",
    studentsAboveClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_students_abovegrade_click",
    studentsBelowClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_students_belowgrade_click",
    durationClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_size_click",
    durationTooltipShow: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_sizetip_hover",
    gradeChange: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_grade_click",
    domainChange: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_domen_click",
    skillChange: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_skill_click",
    cardsPreviewClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_preview_click",
    cardPlayClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_play_click",
    submitClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_complete_click",
    addMoreModalClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_addmore_click",
    goToAssignmentsListModalClick: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage + "_goback_click",
};
var AssignmentDetailsPageEvents = {
    studentClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage + "_student_click",
    cancelClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage + "_cancel_click",
    reassignClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage + "_reassign_click",
    cardPlayClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage + "_playcard_click",
    editNameClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage + "_rename_click",
    editDateClick: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage + "_calendar_click",
};
var ASSIGNMENTS_EVENTS = [
    AssignmentsListPageEvents,
    AssignmentDetailsPageEvents,
    CreateAssignmentPageEvents,
].reduce(function (acc, eventsMap) {
    Object.values(eventsMap).forEach(function (eventName) {
        var _a;
        acc = __assign(__assign({}, acc), (_a = {}, _a[eventName] = eventName, _a));
    });
    return acc;
}, {});
export { ASSIGNMENTS_EVENTS, ASSIGNMENTS_EVENT_CATEGORIES };
